module.exports = __webpack_public_path__ + "static/img/newlogo.10ccc1cc.png";